exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fl-engagement-thank-you{position:absolute;width:100vw;background:#fff;top:0;font-weight:300;color:#d06f6e;letter-spacing:4px;text-shadow:0 2px 4px rgba(0,0,0,.04);text-align:center}@media(min-width:768px){.fl-engagement-thank-you{height:calc(100vh - 100px);margin-top:100px;font-size:40px;padding-top:100px}}@media(max-width:767px){.fl-engagement-thank-you{height:calc(100vh - 60px);margin-top:60px;padding-top:60px;font-size:20px}}", ""]);

// exports
